import { MOCK_TAGGED_TRANSACTIONS_EN } from './locales/en/mock-tagged-transactions.js';
import { MOCK_TAGGED_TRANSACTIONS_EN_US } from './locales/en-us/mock-tagged-transactions.js';
import { MOCK_TAGGED_TRANSACTIONS_JA } from './locales/ja/mock-tagged-transactions.js';
import { MOCK_TAGGED_TRANSACTIONS_KO } from './locales/ko/mock-tagged-transactions.js';
import { MOCK_TAGGED_TRANSACTIONS_ZH_CN } from './locales/zh-cn/mock-tagged-transactions.js';
import { MOCK_TAGGED_TRANSACTIONS_ZH_TW } from './locales/zh-tw/mock-tagged-transactions.js';

/**
 * @typedef {Object} MockTaggedTransaction
 * @property {string} id
 * @property {string} date
 * @property {string} type
 * @property {number} amount
 * @property {string} description
 * @property {string} accountId
 * @property {string} accountName
 * @property {string} currency
 * @property {string} currencySymbol
 * @property {number} currencyDecimalPlaces
 * @property {string} tagNames
 */

/** @type {Record<string, Array<MockTaggedTransaction>>} */
const TAGGED = {
	en: MOCK_TAGGED_TRANSACTIONS_EN,
	'en-US': MOCK_TAGGED_TRANSACTIONS_EN_US,
	ja: MOCK_TAGGED_TRANSACTIONS_JA,
	ko: MOCK_TAGGED_TRANSACTIONS_KO,
	'zh-CN': MOCK_TAGGED_TRANSACTIONS_ZH_CN,
	'zh-TW': MOCK_TAGGED_TRANSACTIONS_ZH_TW,
};

/**
 * @param {string} lang
 * @returns {Array<MockTaggedTransaction>}
 */
export function getMockTaggedTransactions(lang) {
	return TAGGED[lang] ?? MOCK_TAGGED_TRANSACTIONS_EN;
}
